<template>
    <ul class="nav nav-tabs nav-justified">
        <li v-for="tab in model">
            <button
                class="nav-link"
                :class="{active: tab.selected}"
                data-bs-toggle="tab"
                :data-bs-target="`#${tab.id}`"
                type="button"
                role="tab"
                @click.prevent="selectedTab = tab"
                :aria-controls="tab.id"
                :aria-selected="tab.selected">
                {{ tab.name }}
            </button>
        </li>
    </ul>
    <div class="tab-content">
        <div
            class="tab-pane fade show active border-start border-end border-bottom p-3"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
            tabindex="0">
            <component :is="selectedTab.component" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import {BTab} from ".";
import {ref} from "vue";

const model = defineModel();
const selectedTab = ref<BTab>(model.value.find((x) => x.selected));
</script>
